<template>
  <div class="add-product">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :visible.sync="dialogProduct"
      width="850px"
      top="5vh"
      custom-class="addproductclass"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <template #title>
        <div class="title_header">
          <span> {{ product.id ? $t("addProduct.edit") : $t("addProduct.add") }}</span>
          <el-button v-if="!fromLibrary" style="margin-left: 15px" type="primary" size="mini" @click="chooseLibrary">{{
            $t("product.AddProduct.947601-0")
          }}</el-button>
        </div>
      </template>
      <el-form :label-position="labelPosition" :rules="rules" ref="product" label-width="80px" :model="product">
        <!-- 基础设置 -->
        <el-row :gutter="20">
          {{ $t("product.AddProduct.976199-0") }}
        </el-row>
        <template>
          <el-row :gutter="20">
            <el-col :span="24">
              <!-- 多语言选项卡 -->
              <el-tabs v-model="activeLanguage" @tab-click="handleLanguageTabClick">
                <el-tab-pane
                  v-for="lang in $store.state.langList"
                  :key="lang.value"
                  :label="lang.label"
                  :name="lang.value"
                >
                  <template slot="label">
                    <span>{{ lang.label }}</span>
                    <i
                      v-if="isLanguageFieldEmpty(lang.value, 'name')"
                      class="el-icon-warning"
                      style="color: #f56c6c; margin-left: 5px"
                    ></i>
                  </template>
                </el-tab-pane>
              </el-tabs>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('addProduct.goodsName')" prop="name">
                <el-input
                  v-model="getCurrentLanguageData().name"
                  :placeholder="$t('addProduct.pProductName')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('addProduct.price')" prop="costPrice">
                <el-input
                  v-model="product.costPrice"
                  :placeholder="$t('addProduct.pPrice')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="fromMaterial != '1'">
              <el-form-item :label="$t('addProduct.code')" prop="no">
                <el-input v-model="product.no" :placeholder="$t('addProduct.pCode')" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item :label="$t('addProduct.image')" prop="url" style="margin-bottom: 0">
                <CustomUploadImg :action="uploadUrl" :accept="'.png,.jpg'" :headers="headers" :url.sync="product.url" />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <el-row :gutter="20" style="margin-top: 20px; margin-bottom: 10px">
          <span>{{ $t("product.AddProduct.976199-1") }}</span>
          <template> </template>
          <el-button
            style="margin-left: 10px"
            type="primary"
            round
            size="mini"
            v-if="!isExpand"
            @click="isExpand = true"
            >{{ $t("product.AddProduct.976199-2") }}</el-button
          >
          <el-button style="margin-left: 10px" type="success" round size="mini" v-else @click="isExpand = false">{{
            $t("product.AddProduct.976199-3")
          }}</el-button>
        </el-row>
        <template v-if="isExpand">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$t('product.AddProduct.732826-0')" prop="brand">
                <el-input
                  v-model="product.brand"
                  :placeholder="$t('product.AddProduct.732826-1')"
                  :maxlength="100"
                  :show-word-limit="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="fromMaterial != '1'">
              <el-form-item :label="$t('addProduct.tag')" prop="goodsTags">
                <el-select v-model="product.goodsTags" multiple collapse-tags :placeholder="$t('common.select')">
                  <el-option v-for="item in productTags" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- product details -->
          <el-row :gutter="20">
            <el-form-item :label="$t('product.AddProduct.596166-0')" prop="details">
              <div class="detail-item" v-for="(item, index) in product.details" :key="index">
                <div class="detail-content">
                  <div class="detail-image">
                    <CustomUploadImg
                      :action="uploadUrl"
                      :url.sync="item.url"
                      :headers="headers"
                      :accept="'.jpg,.png,.mp4'"
                      :isType="true"
                      @change="url => updateDetailType(item, url)"
                    />
                    <el-button @click="handlerDeleteDetailRow(index)" type="danger" size="mini" class="delete-btn">
                      {{ $t("product.AddProduct.596166-1") }}
                    </el-button>
                  </div>
                  <div class="detail-desc">
                    <!-- 图片/视频语言选择器 -->
                    <el-tabs
                      v-model="item.currentLang"
                      @tab-click="tab => handleDetailLangChange(item, tab)"
                      type="card"
                      class="detail-tabs"
                    >
                      <el-tab-pane
                        v-for="lang in $store.state.langList"
                        :key="lang.value"
                        :label="lang.label"
                        :name="lang.value"
                      >
                      </el-tab-pane>
                    </el-tabs>
                    <!-- 当前语言的描述输入 -->
                    <el-input
                      class="img_video_desc"
                      :value="getDetailLangContent(item)"
                      @input="val => setDetailLangContent(item, val)"
                      type="textarea"
                      :placeholder="$t('product.AddProduct.596166-2')"
                      :resize="false"
                      maxlength="500"
                      show-word-limit
                      :rows="4"
                    >
                    </el-input>
                  </div>
                </div>
              </div>
              <!-- add row -->
              <div class="detail-footer">
                <div class="detail-tip">
                  <i class="el-icon-warning-outline"></i>
                  {{ $t("product.AddProduct.596166-3") }}
                </div>
                <el-button
                  @click="handlerAddDetailRow"
                  type="primary"
                  size="small"
                  icon="el-icon-plus"
                  :disabled="!product.details || product.details.length >= 5"
                >
                  {{ $t("product.AddProduct.596166-4") }} ({{ product.details ? product.details.length : 0 }}/5)
                </el-button>
              </div>
            </el-form-item>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('addProduct.describe')" prop="content">
                <el-input
                  v-model="getCurrentLanguageData().content"
                  type="textarea"
                  :rows="4"
                  :placeholder="$t('addProduct.pDescribe')"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('addProduct.introduction')" prop="introduction">
                <el-tiptap
                  @onInit="onInit"
                  @onUpdate="onUpdate"
                  v-model="getCurrentLanguageData().introduction"
                  maxlength="5"
                  :extensions="extensions"
                  :lang="this.$i18n.locale == 'zh_CN' ? 'zh' : this.$i18n.locale == 'en_US' ? 'en' : 'en'"
                  :size="3"
                />
                <div class="el-upload__tip" style="color: red; margin-top: 15px; text-align: right">
                  {{ $t("addProduct.chaoguo") }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button :loading="loadingForm" type="primary" :disabled="loadingForm" @click="submitForm('product')">{{
          fromMaterial === "1" ? $t("product.AddProduct.537115-0") : $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
    <add-product-type v-on:cancel="cancelCreate" :productType="productType" :dialogProductType="dialogProductType">
    </add-product-type>
    <!-- 素材库 -->
    <el-dialog
      :visible.sync="showLibrary"
      @open="openLibrary"
      @close="showLibrary = false"
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('product.AddProduct.255561-0')"
      :close-on-click-modal="false"
    >
      <div class="search">
        <el-input
          style="width: 150px"
          size="small"
          v-model="search.name"
          :placeholder="$t('product.AddProduct.947601-1')"
          @keyup.enter="searchLibrary"
        ></el-input>
        <el-button size="small" type="primary" @click="searchLibrary">{{
          $t("product.AddProduct.947601-2")
        }}</el-button>
      </div>
      <div class="vue-padding" style="margin-top: 10px">
        <el-table
          v-loading="loading"
          :empty-text="$t('common.noData')"
          :element-loading-text="$t('common.loading')"
          :data="tableList"
          style="width: 100%"
          max-height="638"
          :border="true"
        >
          <el-table-column
            prop="name"
            :show-overflow-tooltip="true"
            :label="$t('product.AddProduct.947601-1')"
            :align="'center'"
          ></el-table-column>
          <el-table-column prop="image" :label="$t('product.AddProduct.947601-3')" :align="'center'">
            <template slot-scope="scope">
              <el-image :src="scope.row.url" fit="contain" style="width: 50px; height: 50px"></el-image>
            </template>
          </el-table-column>
          <el-table-column :label="$t('product.AddProduct.947601-4')" :align="'center'" fixed="right">
            <template slot-scope="scope">
              <el-button style="margin: 3px" size="mini" type="success" @click="getLibrary(scope.row)">{{
                $t("product.AddProduct.947601-5")
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="tableList.length > 0"
          background
          layout="prev, pager, next"
          :current-page="page.pageIndex"
          :total="page.totalSize"
          :page-size="page.pageSize"
          @current-change="currentChange"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showLibrary = false">{{ $t("common.cancel") }}</el-button>
      </div></el-dialog
    >
  </div>
</template>

<script>
  import config from "@/http/config";
  import CustomUploadImg from "@/components/CustomUploadImg.vue";
  import {
    // 需要的 extensions
    Doc,
    Text,
    Paragraph,
    Heading,
    Bold,
    Underline,
    Italic,
    Strike,
    ListItem,
    BulletList,
    OrderedList,
    Link,
    Image,
    CodeBlock,
    Blockquote,
    TodoItem,
    TodoList,
    TextAlign,
    FontSize,
    FontType,
    Fullscreen,
    TextHighlight,
    TextColor,
    FormatClear,
    Table,
    TableHeader,
    TableCell,
    TableRow,
    History,
    TrailingNode,
    HardBreak,
    HorizontalRule,
    LineHeight,
    Indent
  } from "element-tiptap";
  export default {
    name: "AddProduct",
    components: { CustomUploadImg },
    props: {
      product: {
        type: Object,
        default: () => ({
          details: []
        })
      },
      dialogProduct: Boolean,
      productTags: Array,
      fromMaterial: {
        type: String,
        default: "0"
      },
      fromLibrary: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isExpand: false,
        productType: {},
        dialogProductType: false,
        labelPosition: "top",
        rules: {
          costPrice: [
            {
              required: true,
              message: this.$t("addProduct.pPrice"),
              trigger: "blur"
            },
            {
              pattern: /^\d+(\.\d{0,2})?$/,
              message: this.$t("addProduct.rPrice")
            }
          ],
          url: [
            {
              required: true,
              message: this.$t("addProduct.pImage"),
              trigger: "change"
            }
          ],
          no: [
            {
              required: true,
              message: this.$t("product.AddProduct.872278-0"),
              trigger: "change"
            }
          ],
          name: [
            {
              required: true,
              message: this.$t("product.AddProduct.872278-1"),
              trigger: "change"
            }
          ]
        },
        machineType: [],
        fileList: [],
        clear: false,
        uploadUrl: config.baseUrl + this.$url.Upload.product,
        headers: {
          token: this.$cookies.get("token")
        },
        loadingForm: false,
        extensions: this.getExtensions(),
        length: 0,
        showLibrary: false,
        search: {
          name: ""
        },
        useSearch: {},
        tableList: [],
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        loading: false,
        activeLanguage: this.$i18n.locale || "zh_CN",
        productLanguages: []
      };
    },
    methods: {
      // 添加判断图片和视频的方法
      isImage(url) {
        if (!url) return false;
        return /\.(jpg|jpeg|png|gif|bmp)$/i.test(url);
      },
      isVideo(url) {
        if (!url) return false;
        return /\.(mp4|webm|ogg|mov|avi)$/i.test(url);
      },
      // 更新detail的type
      updateDetailType(item, url) {
        if (this.isImage(url)) {
          item.type = 0;
        } else if (this.isVideo(url)) {
          item.type = 1;
        } else {
          item.type = -1;
        }
      },
      handlerAddDetailRow() {
        // 确保details存在且为数组
        if (!this.product.details) {
          this.$set(this.product, "details", []);
        }

        if (this.product.details.length >= 5) {
          this.$message.warning(this.$t("product.AddProduct.596166-5"));
          return;
        }
        // 修改为新的数据结构，支持多语言
        const newDetail = {
          type: -1, // 初始设为-1，上传后会根据URL更新
          url: "",
          currentLang: this.activeLanguage, // 默认使用当前活动语言
          language: this.$store.state.langList.map(lang => ({
            lang: lang.value,
            content: ""
          }))
        };
        if (!Array.isArray(this.product.details)) {
          this.$set(this.product, "details", []);
        }
        this.product.details.push(newDetail);
      },
      handlerDeleteDetailRow(index) {
        this.product.details.splice(index, 1);
        if (this.product.details.length <= 0) {
          // 创建一个支持多语言的空详情
          const newDetail = {
            type: -1,
            url: "",
            currentLang: this.activeLanguage, // 默认使用当前活动语言
            language: this.$store.state.langList.map(lang => ({
              lang: lang.value,
              content: ""
            }))
          };
          this.product.details.push(newDetail);
          this.$message.warning(this.$t("product.AddProduct.596166-6"));
        }
      },
      getExtensions() {
        let that = this;
        return [
          new Doc(), // 必须项
          new Text({
            length: 20
          }), // 必须项
          new Paragraph(), // 必须项
          new Heading({ level: 6 }), // 标题
          new Bold({ bubble: true }), // 加粗 bubble: true 在气泡菜单中渲染菜单按钮
          new Underline({ bubble: true, menubar: false }), // 下划线 bubble: true, menubar: false 在气泡菜单而不在菜单栏中渲染菜单按钮
          new Italic({ bubble: true }), // 斜体
          new Strike({ bubble: true }), // 删除线
          new ListItem(), // 使用列表必须项
          new BulletList({ bubble: true }), // 无序列表
          new OrderedList({ bubble: true }), // 有序列表
          new Link(), // 链接
          new Image({
            // 默认会把图片生成 base64 字符串和内容存储在一起，如果需要自定义图片上传
            // 自定义图片上传(默认会把图片生成base64字符串和内容存储到一起)
            // 图片的上传方法，返回一个 Promise<url>
            async uploadRequest(file) {
              // 如果接口要求 Content-Type 是 multipart/form-data，则请求体必须使用 FormData
              const formdata = new FormData();
              //  image是后台接口需要参数名
              formdata.append("file", file);
              //  调用接口进行上传,拿到服务器返回的图片地址
              const res = await that.$api.request(that.$url.common.upload, that.$method.post, formdata);

              if (res.code === 0) {
                return res.data;
              }
              that.$message.warning(res.msg);
              return false;
            }
          }), // 图片
          new CodeBlock({ bubble: true }), // 代码块
          new Blockquote(), // 引用
          new TodoItem(), // 任务列表必须项
          new TodoList(), // 任务列表
          new TextAlign({ bubble: true }), // 文本对齐方式
          new FontSize({ bubble: true }), // 字号
          new FontType({ bubble: true }), // 字体
          new Fullscreen(), // 全屏
          new TextHighlight({ bubble: true }), // 文本高亮
          new TextColor({ bubble: true }), // 文本颜色
          new FormatClear({ bubble: true }), // 清除格式
          new Table({ resizable: true }), // 表格
          new TableHeader(), // 表格必须项
          new TableCell(), // 表格必须项
          new TableRow(), // 表格必须项
          new History(), // 撤销
          new TrailingNode(), // 重做
          new HardBreak(), // 分割线
          new HorizontalRule(), // 行距
          new LineHeight(), // 增加缩进
          new Indent() // 减少缩进
        ];
      },
      handlerCreateProductType() {
        this.dialogProductType = true;
      },
      cancelCreate() {
        this.dialogProductType = false;
      },
      onInit({ editor }) {},
      onUpdate(editor) {
        var content = editor.replace(/<.*?>/g, "");
        this.length = content.length;
      },
      cancel(state, code) {
        this.$emit("cancel", false, state, code);
      },
      submitForm(formName) {
        if (this.length > 5000) {
          this.$notify({
            title: this.$t("common.tip"),
            message: this.$t("addProduct.chaoguo"),
            type: "error"
          });
          return false;
        }

        // 检查是否所有必填的语言都已填写
        let hasEmptyName = false;
        this.productLanguages.forEach(lang => {
          if (!lang.name || lang.name.trim() === "") {
            hasEmptyName = true;
          }
        });

        if (hasEmptyName) {
          this.$notify({
            title: this.$t("common.tip"),
            message: this.$t("addProduct.pProductName"),
            type: "error"
          });
          return false;
        }

        // 将当前语言的名称同步到product中用于验证，确保其他验证规则也能正常工作
        const currentLang = this.getCurrentLanguageData();
        this.product.name = currentLang.name;

        this.$refs[formName].validate(valid => {
          if (valid) {
            this.loadingForm = true;
            let url = this.$url.Product.insert;
            let method = this.$method.post;
            if (this.product.id) {
              url = this.$url.Product.update;
              method = this.$method.put;
            }
            // 添加素材库商品
            if (this.fromMaterial === "1") {
              url = this.$url.ProductLibrary.insert;
              method = this.$method.post;
            }
            let goodsTags = [];
            if (this.product.goodsTags) {
              this.product.goodsTags.forEach(key => {
                let obj = { goodsTagId: key };
                console.log(obj, "obj");
                goodsTags.push(obj);
              });
            }

            // 添加多语言数据
            this.product.language = this.productLanguages;

            // 筛选details，去除空项
            if (this.product.details && this.product.details.length > 0) {
              // 首先确保每个detail的type值正确设置
              this.product.details.forEach(item => {
                // 重新根据URL判断正确的type值
                if (item.url) {
                  if (this.isImage(item.url)) {
                    item.type = 0; // 图片类型
                  } else if (this.isVideo(item.url)) {
                    item.type = 1; // 视频类型
                  }
                }
              });

              const filteredDetails = this.product.details.filter(item => {
                // 判断是否为空项：url为空且所有语言content都为空
                if (!item.url) {
                  // 检查所有语言的content是否都为空
                  const allContentsEmpty =
                    !item.language || item.language.every(lang => !lang.content || lang.content.trim() === "");
                  return !allContentsEmpty; // 返回非空项
                }
                return true; // 保留非空项
              });

              // 更新过滤后的details
              this.product.details = filteredDetails.length > 0 ? filteredDetails : undefined;
            }

            this.$api
              .request(url, method, { ...this.product, goodsTags })
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: res.msg,
                    type: "success"
                  });
                  this.clear = true;
                  this.cancel(this.product.id ? "update" : "save");
                } else {
                  this.$message.warning(res.msg);
                }
                this.loadingForm = false;
              })
              .catch(err => {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: err.msg,
                  type: "error"
                });
                this.loadingForm = false;
              });
          }
        });
      },
      closeDialog() {
        this.clearValidate("product");
        this.machineType = [];
        if (this.product.id) {
          this.$toolUtil.clearForm(this.product);
        } else {
          if (this.clear) {
            this.$toolUtil.clearForm(this.product);
          }
        }
        this.cancel("");
      },
      openDialog() {
        this.fileList = [];
        if (this.product.url) {
          this.fileList.push({ name: "uploaded_image", url: this.product.url });
        }
        let arr = [];
        if (this.product.goodsTags) {
          this.product.goodsTags.forEach(key => {
            arr.push(key.goodsTagId);
          });
        }
        this.product.goodsTags = arr;

        // 初始化多语言数据
        this.initLanguageData();

        // 确保details中的每个项目都有语言数据结构
        if (!this.product.details) {
          this.$set(this.product, "details", []);
        }

        if (this.product.details && this.product.details.length > 0) {
          this.product.details = JSON.parse(JSON.stringify(this.product.details));

          // 根据URL判断并设置type值
          this.product.details = this.product.details.map(item => {
            if (this.isImage(item.url)) {
              item.type = 0;
            } else if (this.isVideo(item.url)) {
              item.type = 1;
            }

            // 设置当前选中的语言
            this.$set(item, "currentLang", this.activeLanguage);

            // 如果没有language字段或为空，则初始化
            if (!item.language || item.language.length === 0) {
              this.$set(
                item,
                "language",
                this.$store.state.langList.map(lang => ({
                  lang: lang.value,
                  content: item.title || "" // 兼容旧数据，将title作为默认内容
                }))
              );
            }
            return item;
          });
        } else {
          // 如果details不存在或为空，初始化一个空的详情项
          this.$set(this.product, "details", [
            {
              type: -1,
              url: "",
              currentLang: this.activeLanguage,
              language: this.$store.state.langList.map(lang => ({
                lang: lang.value,
                content: ""
              }))
            }
          ]);
        }

        // 节约性能 执行一次
        if (this.fromMaterial != "1") {
          this.currentChange();
        }
      },
      // 初始化多语言数据
      initLanguageData() {
        // 获取系统支持的语言列表
        const langList = this.$store.state.langList || [];

        // 如果产品已有语言数据，使用现有数据
        if (this.product.language && this.product.language.length > 0) {
          this.productLanguages = JSON.parse(JSON.stringify(this.product.language));
        } else {
          // 否则为每种语言创建一个空记录
          this.productLanguages = langList.map(lang => {
            return {
              lang: lang.value,
              name: this.product.name || "",
              content: this.product.content || "",
              introduction: this.product.introduction || "",
              details: this.product.details || []
            };
          });
        }

        // 设置当前活动语言
        this.activeLanguage = this.$i18n.locale || "zh_CN";

        // 确保所有支持的语言都有对应的数据
        langList.forEach(lang => {
          if (!this.productLanguages.some(item => item.lang === lang.value)) {
            this.productLanguages.push({
              lang: lang.value,
              name: this.product.name || "",
              content: this.product.content || "",
              introduction: this.product.introduction || "",
              details: this.product.details || []
            });
          }
        });
      },
      // 获取当前语言的产品数据
      getCurrentLanguageData() {
        let data = this.productLanguages.find(item => item.lang === this.activeLanguage);
        if (!data) {
          // 如果没有找到当前语言的数据，创建一个新的
          data = {
            lang: this.activeLanguage,
            name: "",
            content: "",
            introduction: "",
            details: []
          };
          this.productLanguages.push(data);
        }
        return data;
      },
      // 切换语言
      handleLanguageTabClick(tab) {
        this.activeLanguage = tab.name;
        // 触发表单验证更新
        this.$nextTick(() => {
          this.$refs["product"].validateField("name");
        });
      },
      // 清除表单校验
      clearValidate(formName) {
        this.$refs[formName].clearValidate();
      },

      // 选择素材
      chooseLibrary() {
        this.showLibrary = true;
      },
      searchLibrary() {
        this.currentChange(1, true);
      },
      currentChange(pageIndex, isSearch) {
        if (isSearch) {
          this.useSearch = JSON.parse(JSON.stringify(this.search));
        }
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.useSearch, this.page);
        obj.searchType = 1;
        this.$api
          .request(this.$url.ProductLibrary.page, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.tableList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      getLibrary(row) {
        // 先保存图片URL以便后续重新上传
        const imageUrl = row.url;
        // 保存details数据以便后续处理
        const details = row.details ? JSON.parse(JSON.stringify(row.details)) : [];

        // 复制属性（除了url、details和id）
        Object.keys(this.product).forEach(key => {
          if (key === "id") return;
          if (key === "url") return; // 不复制url，稍后会重新上传
          if (key === "details") return; // 不复制details，稍后会重新处理
          if (key === "language") return; // 不直接复制语言数据，而是手动处理
          this.product[key] = row[key];
        });

        // 确保id为undefined（新增），除非当前是编辑模式
        if (!this.product.id) {
          this.product.id = undefined;
        }

        //确保details中的id为空
        if (row.details?.length > 0) {
          row.details.forEach(item => {
            delete item.id;
            if (item.language?.length > 0) {
              item.language.forEach(ite => delete ite.id);
            }
          });
        }
        //确保lang语言id为空
        if (row.language?.length > 0) {
          row.language.forEach(item => delete item.id);
        }

        // 手动清理this.product.details中可能存在的ID
        if (this.product.details?.length > 0) {
          this.product.details.forEach(item => {
            delete item.id;
            if (item.language?.length > 0) {
              item.language.forEach(lang => delete lang.id);
            }
          });
        }

        // 处理多语言数据
        if (row.language && row.language.length > 0) {
          // 创建一个没有ID的语言数据副本
          this.productLanguages = row.language.map(lang => {
            const newLang = { ...lang };
            delete newLang.id;
            return newLang;
          });
        } else {
          // 初始化多语言数据
          this.initLanguageData();
        }

        // 加载状态
        this.loadingForm = true;
        this.$notify({
          title: this.$t("common.tip"),
          message: this.$t("product.AddProduct.596166-7"),
          type: "info"
        });

        // 创建所有上传任务的数组
        const uploadTasks = [];

        // 添加主图片上传任务
        if (imageUrl) {
          uploadTasks.push(this.reuploadImageFromUrl(imageUrl));
        }

        // 添加详情媒体上传任务
        uploadTasks.push(
          this.reuploadDetailsMedia(details).then(newDetails => {
            // 更新details数据
            this.$set(this.product, "details", newDetails);

            // 确保details中没有ID
            if (this.product.details && this.product.details.length > 0) {
              this.product.details = this.product.details.map(item => {
                const newItem = { ...item };
                delete newItem.id; // 删除ID

                // 设置当前选中的语言
                if (!newItem.currentLang) {
                  newItem.currentLang = this.activeLanguage;
                }

                // 如果没有language字段或为空，则初始化
                if (!newItem.language || newItem.language.length === 0) {
                  newItem.language = this.$store.state.langList.map(lang => ({
                    lang: lang.value,
                    content: newItem.title || "" // 兼容旧数据，将title作为默认内容
                  }));
                } else {
                  // 确保language中没有ID
                  newItem.language = newItem.language.map(lang => {
                    const cleanLang = { ...lang };
                    delete cleanLang.id;
                    return cleanLang;
                  });
                }
                return newItem;
              });
            }
          })
        );

        // 等待所有上传任务完成
        Promise.all(uploadTasks)
          .then(() => {
            this.loadingForm = false;
            this.$notify({
              title: this.$t("common.tip"),
              message: this.$t("product.AddProduct.596166-8"),
              type: "success"
            });
          })
          .catch(err => {
            this.loadingForm = false;
            this.$notify({
              title: this.$t("common.tip"),
              message: this.$t("product.AddProduct.596166-9"),
              type: "warning"
            });
          });

        this.showLibrary = false;
      },
      // 添加一个新方法用于从URL重新上传图片
      reuploadImageFromUrl(url) {
        // 返回Promise以便调用者等待完成
        return new Promise((resolve, reject) => {
          // 先通过fetch获取图片数据
          fetch(url)
            .then(response => response.blob())
            .then(blob => {
              // 创建FormData对象并添加文件
              const formData = new FormData();
              // 根据URL后缀确定文件类型和文件名
              const fileExtension = url.split(".").pop().toLowerCase();
              const fileName = `reupload_${Date.now()}.${fileExtension}`;
              const file = new File([blob], fileName, { type: `image/${fileExtension}` });
              formData.append("file", file);

              // 调用上传接口
              return this.$api.request(this.$url.Upload.product, this.$method.post, formData);
            })
            .then(res => {
              if (res.code === 0) {
                // 更新产品URL
                this.product.url = res.data;
                // 更新显示
                this.fileList = [{ name: "uploaded_image", url: res.data }];
                resolve(res.data);
              } else {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg || this.$t("product.AddProduct.reupload_failed"),
                  type: "error"
                });
                reject(new Error(res.msg || this.$t("product.AddProduct.596166-10")));
              }
            })
            .catch(err => {
              this.$notify({
                title: this.$t("common.tip"),
                message: this.$t("product.AddProduct.reupload_failed"),
                type: "error"
              });
              reject(err);
            });
        });
      },
      // 重新上传details中的图片或视频
      reuploadDetailsMedia(details) {
        if (!details || details.length === 0) return Promise.resolve([]);

        // 确保每个详情项没有ID
        const cleanDetails = details.map(item => {
          const cleanItem = { ...item };
          delete cleanItem.id; // 删除详情项ID

          // 确保language中没有ID
          if (cleanItem.language && cleanItem.language.length > 0) {
            cleanItem.language = cleanItem.language.map(lang => {
              const cleanLang = { ...lang };
              delete cleanLang.id;
              return cleanLang;
            });
          }

          return cleanItem;
        });

        const promises = cleanDetails.map(item => {
          if (!item.url) return Promise.resolve(item);

          return new Promise(resolve => {
            fetch(item.url)
              .then(response => response.blob())
              .then(blob => {
                // 创建FormData对象并添加文件
                const formData = new FormData();
                const fileExtension = item.url.split(".").pop().toLowerCase();
                const fileName = `reupload_detail_${Date.now()}.${fileExtension}`;
                const fileType = this.isImage(item.url) ? "image" : "video";
                const file = new File([blob], fileName, { type: `${fileType}/${fileExtension}` });
                formData.append("file", file);

                // 如果需要添加type参数
                if (this.isImage(item.url)) {
                  formData.append("type", "0"); // 0表示图片
                } else if (this.isVideo(item.url)) {
                  formData.append("type", "1"); // 1表示视频
                }

                return this.$api.request(this.$url.Upload.product, this.$method.post, formData);
              })
              .then(res => {
                if (res.code === 0) {
                  const newItem = { ...item };
                  newItem.url = res.data;
                  resolve(newItem);
                } else {
                  resolve(item); // 返回原始项
                }
              })
              .catch(err => {
                resolve(item); // 返回原始项
              });
          });
        });

        return Promise.all(promises);
      },
      // 同步基本信息到所有语言
      syncBaseInfoToAllLanguages() {
        // 当基本信息(如价格、图片等)更改时，可以调用此方法
        const baseProduct = this.product;
        this.productLanguages.forEach(lang => {
          // 只同步一次基本信息，不覆盖已有的语言特定内容
          if (!lang.name && baseProduct.name) {
            lang.name = baseProduct.name;
          }
        });
      },
      // 检查语言字段是否为空
      isLanguageFieldEmpty(langCode, field) {
        const langData = this.productLanguages.find(item => item.lang === langCode);
        return !langData || !langData[field] || langData[field].trim() === "";
      },
      // 处理详情中语言切换
      handleDetailLangChange(detail, tab) {
        // 确保currentLang已更新
        detail.currentLang = tab.name;
      },
      // 获取详情当前选中语言的内容
      getDetailLangContent(detail) {
        if (!detail.language) return "";
        const langData = detail.language.find(item => item.lang === detail.currentLang);
        return langData ? langData.content : "";
      },
      // 设置详情当前选中语言的内容
      setDetailLangContent(detail, content) {
        if (!detail.language) {
          detail.language = this.$store.state.langList.map(lang => ({
            lang: lang.value,
            content: lang.value === detail.currentLang ? content : ""
          }));
          return;
        }

        const langData = detail.language.find(item => item.lang === detail.currentLang);
        if (langData) {
          langData.content = content;
        } else {
          detail.language.push({
            lang: detail.currentLang,
            content: content
          });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .el-upload-list--picture-card .el-upload-list__item {
    margin: 0;
  }
  .quill-editor editor {
    height: 600px !important;
  }
  .ql-container ql-snow {
    height: 480px !important;
  }
  .addproductclass .el-dialog__header {
    padding: 20px;
  }
  .addproductclass .el-dialog__body {
    margin: 0 !important;
    height: auto;
  }
  .addproductclass .el-dialog__footer {
    padding: 0 20px 20px 20px;
  }
  .addproductclass .el-form--label-top .el-form-item__label {
    padding-bottom: 0;
  }
  .addproductclass .el-form-item {
    margin-bottom: 15px;
  }
  .title_header {
    line-height: 24px;
    font-size: 18px;
    color: #303133;
    display: flex;
    align-items: center;
  }
  .search {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  ::v-deep .el-dialog__body {
    height: auto;
  }
  .img_video_desc {
    ::v-deep .el-textarea__inner {
      height: 100% !important;
    }
  }
  .detail-item {
    margin-bottom: 15px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px;
    background-color: #f9f9f9;
  }
  .detail-content {
    display: flex;
    gap: 15px;
  }
  .detail-image {
    position: relative;
    min-width: 120px;
  }
  .delete-btn {
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 5px 8px;
    font-size: 12px;
  }
  .detail-desc {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .detail-tabs {
    margin-bottom: 10px;
    ::v-deep .el-tabs__header {
      margin-bottom: 10px;
    }
    ::v-deep .el-tabs__nav {
      border: none;
    }
    ::v-deep .el-tabs__item {
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
    }
  }
  .detail-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
  }
  .detail-tip {
    color: #f56c6c;
    font-size: 12px;
    display: flex;
    align-items: center;
    i {
      margin-right: 5px;
    }
  }
</style>
